import React, { useState, useEffect } from "react";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { TextField } from '@mui/material';
import "./OptionExpirationDatePicker.scss";

const OptionExpirationDatePicker = ({ defaultDate, onDateSelect, availableDates = [], disabled = false, placeholder = "Expiration Date" }) => {
    const [selectedDate, setSelectedDate] = useState(null);

    useEffect(() => {
        if (defaultDate) {
            const dateParts = defaultDate.split('-');
            const date = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
            if (!isNaN(date.getTime())) {
                setSelectedDate(date);
            }
        } else {
            setSelectedDate(null);
        }
    }, [defaultDate]);

    const shouldDisableDate = (date) => {
        if (!availableDates.length) return true;
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const dateString = `${year}-${month}-${day}`;
        return !availableDates.includes(dateString);
    };

    const handleDateChange = (date) => {
        if (date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const dateString = `${year}-${month}-${day}`;
            setSelectedDate(date);
            onDateSelect(dateString);
        } else {
            setSelectedDate(null);
            onDateSelect("");
        }
    };

    const minDate = availableDates.length > 0 ? (() => {
        const earliestDate = availableDates[0];
        const dateParts = earliestDate.split('-');
        return new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
    })() : null;
    
    const maxDate = availableDates.length > 0 ? (() => {
        const latestDate = availableDates[availableDates.length - 1];
        const dateParts = latestDate.split('-');
        return new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
    })() : null;

    return (
        <div className="option-expiration-datepicker">
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                    value={selectedDate}
                    onChange={handleDateChange}
                    minDate={minDate}
                    maxDate={maxDate}
                    shouldDisableDate={shouldDisableDate}
                    disabled={disabled}
                    format="yyyy-MM-dd"
                    slots={{
                        textField: TextField
                    }}
                    slotProps={{
                        textField: {
                            size: 'small',
                            placeholder: placeholder,
                            className: 'mui-datepicker-input',
                            disabled: disabled,
                            fullWidth: true,
                            inputProps: {
                                readOnly: true
                            }
                        }
                    }}
                />
            </LocalizationProvider>
        </div>
    );
};

export default OptionExpirationDatePicker;